<template>
  <overlay show>
    <popup v-bind="$props" @close="onClose" @back="onBack" @action="onAction">
      <slot slot="main" name="main" />
    </popup>
  </overlay>
</template>

<script>
import Overlay from './overlay'
import Popup from './popup'

export default {
  components: {
    overlay: Overlay,
    popup: Popup,
  },
  methods: {
    onAction() {
      this.$emit('action')
    },
    onBack() {
      this.$emit('back')
    },
    onClose() {
      this.$emit('close')
    },
  },
  props: {
    actionTitle: {
      default: '',
      type: String,
    },

    /**
     * Route path for back link
     */
    backPath: {
      default: '',
      type: String,
    },

    /**
     * Route query for back link
     */
    backQuery: {
      default: () => {},
      type: Object,
    },

    /**
     * Whether to use large layout
     */
    large: {
      default: false,
      type: Boolean,
    },

    /**
     * Whether to show back button
     */
    showBack: {
      default: false,
      type: Boolean,
    },

    /**
     * Whether to show close button
     */
    showClose: {
      default: true,
      type: Boolean,
    },

    /**
     * Whether to show masthead
     */
    showMasthead: {
      default: false,
      type: Boolean,
    },

    /**
     * Whether to use small layout
     */
    small: {
      default: false,
      type: Boolean,
    },
  },
}
</script>
